/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v10h-2V5.227l-8 7.111-8-7.111V18h7v2H2zm3.63 2L12 9.662 18.37 4z" />
        <path d="M23 19v-2h-1.141a3.956 3.956 0 0 0-.425-1.02l.808-.808-1.414-1.415-.808.809a3.956 3.956 0 0 0-1.02-.425V13h-2v1.141a3.956 3.956 0 0 0-1.02.425l-.808-.809-1.415 1.415.809.808c-.186.316-.33.656-.425 1.02H13v2h1.141c.095.364.239.704.425 1.02l-.809.808 1.414 1.414.809-.808c.316.186.656.33 1.02.425V23h2v-1.141a3.991 3.991 0 0 0 1.02-.425l.808.808 1.414-1.414-.808-.808c.187-.316.33-.656.425-1.02zm-5 1a2 2 0 1 1 .001-4.001A2 2 0 0 1 18 20z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmailSettings as EmailSettings };
